import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeatMapComponent } from './heat-map.component';
import { HeatMapRoutingModule } from './heat-map-routing.module';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxTreeMapModule } from 'devextreme-angular';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';

@NgModule({
  declarations: [HeatMapComponent],
  imports: [
    CommonModule,
    HeatMapRoutingModule,
    DxTreeMapModule,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent,
    DevEpressCommonModule, WebExportModule, BookmarkModule
  ]
})
export class HeatMapModule { }
